<style lang="scss">
    @import "../../../../sass/layout/tables";
    .org-width { 
        /* max-width: 180px; */
        word-wrap: break-word;
    }
</style>

<style lang="scss" scoped>
    // override styles from tables layout
    .table-template .page-item:first-child .page-link,
    .table-template .page-item:last-child .page-link {
        font-size: 2.0em;
    }
</style>

<template>
    <div class="users-list table-template">
        <div label="Filter" class="form-group d-md-none not-generic-form">
            <div class="input-group">
                <select v-model="sortBy" class="custom-select">
                    <option slot="first" :value="null">-- Filter --</option>
                    <option v-for="option in sortFields" :value="option.key">{{ option.text }}</option>
                </select>
                <select :disabled="!sortBy" v-model="sortDesc">
                    <option :value="false">Asc</option>
                    <option :value="true">Desc</option>
                </select>
            </div>

            <div class="input-group border-search">
                <input type="text" class="form-control" v-model="filter" placeholder="Search by County or Consultant Name" />
                <div class="input-group-append">
                    <i class="fa fa-search my-auto"></i>
                </div>
            </div>
        </div>

        <div class="row rounded-top consultants">
            <div class="arrow-consultants">
                <img :src="$basePath + '/images/orange_arrow_blue_border.png'">
                <span class="table-title">Consultants</span>
            </div>
            <div class="border-search d-none d-md-block">
                <div class="input-group">
                    <input type="text" class="form-control" v-model="filter" placeholder="Search by County or Consultant Name" />
                    <div class="input-group-append">
                        <i class="fa fa-search my-auto"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center border border-info border-top-0" v-if="loading">
            <div class="fa-3x pt-3 pb-1">
                <i class="fas fa-spinner fa-pulse" style="color:#91ccda;"></i>
            </div>
        </div>
        <div v-else>
            <div class="row justify-content-center">
                <table class="table mb-0">
                    <thead>
                        <tr>
                            <th v-for="field in fields">{{ field.label }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in paginatedItems">
                            <td>
                                <a v-bind:href="$basePath+'/consultants/'+item.id">{{ item.name }}</a>
                            </td>
                            <td>
                                {{ item.organization_type ? item.organization_type.name : '--' }}
                            </td>
                            <td>
                                {{ (item.program_count) ? item.program_count : 0 }} Programs Connected <br />
                                {{ (item.child_count) ? item.child_count : 0 }} Children Served
                            </td>
                            <td>
                                <div v-if="item.counties_served">
                                    <div v-for="(county_served, index) in item.counties_served">
                                        <span v-show="item.show_all_counties || index < 3">{{ county_served.name }}</span><span v-if="index+1 < item.counties_served.length" v-show="item.show_all_counties || index < 3">, </span>
                                    </div>
                                    <span v-if="item.counties_served.length > 3" v-on:click="toggleShowCounties(item)">
                                        <span v-if="item.show_all_counties" class="btn-link small">less</span>
                                        <span v-else class="btn-link">...</span>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div v-if="item.latest_activity_log">
                                    <span>{{ formatDate(item.latest_activity_log.date) }}</span>
                                </div>
                                <div v-else>
                                    --
                                </div>
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
            <div class="row pagination-row justify-content-center">
                <nav aria-label="Navigation for Consultants list">
                    <ul class="pagination">
                        <li class="page-item" role="presentation" :aria-hidden="currentPage==1"><button class="page-link" :disabled="currentPage==1" :aria-disabled="currentPage==1" @click="prevPage" aria-label="Go to previous page">&lt;</button></li>
                        <li v-for="n in pageCount" class="page-item" :class="{active: n==currentPage}"><button class="page-link" @click="setPage(n)" role="menuitemradio" :aria-label="`Go to page ${n}`">{{ n }}</button></li>
                        <li class="page-item" role="presentation" :aria-hidden="currentPage==pageCount"><button class="page-link" :disabled="currentPage==pageCount" :aria-disabled="currentPage==pageCount" @click="nextPage" aria-label="Go to next page">&gt;</button></li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment'

    export default {
        components: {
            moment
        },
        data: function () {
            return {
                users: [],
                fields: [
                    { key: 'name', label: 'Consultant Name', sortable: true },
                    { key: 'organization_type', label: 'Organization Type', sortable: true, 'class': 'org-width'},
                    { key: 'connections', label: 'Connections', sortable: true},
                    { key: 'counties_served', label: 'County', sortable: true },
                    { key: 'latest_activity_log', label: 'TA Activity', sortable: true }
                ],
                state: this.state,
                currentPage: 1,
                perPage: 5,
                loading: true,
                sortBy: null,
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                loading: true
            }
        },
        methods: {
            fetchUsers: function () {
                axios.get('/api/consultants/list?with=connections,countiesServed,organizationType,program,program.consultants,program.county')
                .then(function(response){ 
                    this.users = response.data.data
                    this.loading = false
                }.bind(this))
                .catch(function(error){
                    // console.error(error)
                 })
            },
            toggleShowCounties: function( data ) {
                //this.show_all_counties = !this.show_all_counties;
                if (data.hasOwnProperty('show_all_counties')) {
                    data.show_all_counties = !data.show_all_counties;
                } else {
                    //since its the first time , set the value pf show_all_counties to true to show the subitem
                    //data = Object.assign({}, data, {show_all_counties: false});
                    //Vue.set(data, 'show_all_counties', false);
                    this.$set(data, 'show_all_counties', true);
                }
            },
            setPage: function(page) {
                this.currentPage = page;
            },
            nextPage: function() {
                if(this.currentPage >= this.pageCount) {
                    this.currentPage = this.pageCount;
                } else {
                    this.currentPage++;
                }
            },
            prevPage: function() {
                if(this.currentPage <= 1) {
                    this.currentPage = 1;
                } else {
                    this.currentPage--;
                }
            },
            formatDate: function (value) {
            if (value) {
                    return moment(String(value)).format('MM/DD/YYYY')
                }
            },
        },
        computed: {
            sortFields: function () {
                if (this.fields) {
                    return this.fields
                        .filter(f => f.sortable)
                        .map(f => { return { text: f.label, value: f.key } })
                }
                return new Array();
            },
            pageCount: function() {
                return Math.ceil(this.users.length/this.perPage);
            },
            paginatedItems: function() {
                let start = (this.currentPage-1) * this.perPage;
                return this.users.slice(start, start + this.perPage);
            }
        },
        mounted: function () {
            this.fetchUsers();
        }
    }
</script>